import { ApiBase } from "config";
import { IListResponse } from "common/models/GridModels";
import api from "utils/api";
import {
  IMemberTypewiseSectionConfig,
  IMemberTypewiseSectionConfigGridFilter,
  IMemberTypewiseSectionConfigGridModel,
} from "./memberTypewiseSectionConfig.types";
import { PostModel } from "contexts/LovelyGridContext";
import { memberTypewiseSectionConfigView } from "../types/memberTypewiseSectionConfigView";

const baseUrl = `${ApiBase}/api/memberTypewiseSectionConfig`;

function getAll(
  model: PostModel<IMemberTypewiseSectionConfigGridFilter> | undefined
) {
  return api.post<IListResponse<IMemberTypewiseSectionConfigGridModel>>(
    `${baseUrl}/list`,
    model
  );
}

function getById(id: string | number) {
  return api.get<IMemberTypewiseSectionConfig>(`${baseUrl}/${id}`);
}

async function create(data: IMemberTypewiseSectionConfig) {
  return api.post<number>(`${baseUrl}/create`, data);
}

async function update(model: IMemberTypewiseSectionConfig) {
  return api.post<number>(`${baseUrl}/update`, model);
}

function _delete(id: string | number) {
  return api.get<number>(`${baseUrl}/delete/${id}`);
}

function getViewById(id: string | number) {
  return api.get<memberTypewiseSectionConfigView>(`${baseUrl}/view/${id}`);
}

export default {
  getAll,
  getById,
  create,
  update,
  delete: _delete,
  getViewById,
};
